import React from 'react'
import { inject, observer } from 'mobx-react'

import Input from '../../../generic/Input'
import FormRenderer from '../../../generic/FormRenderer'
import MultiSelect from '../../../generic/MultiSelect'

const EditGroupForm = inject('configGroupsStore')(observer(props => {
  const { configGroupsStore } = props
  const { permissions } = configGroupsStore.state
  const { name } = configGroupsStore.state.editGroup
  const selectedPermissions = configGroupsStore.state.editGroup.permissions
  const formFields = [{
    component: Input,
    label: 'Nome',
    type: 'text',
    name: 'name',
    id: 'edit-group-name',
    placeholder: 'Nome',
    value: name,
    handler: (e) => configGroupsStore.setEditGroupName(e.target.value)
  },{
    component: MultiSelect,
    label: 'Permissões',
    placeholder: 'Selecionar permissões',
    value: selectedPermissions.map(data => {
      return {value: data, label: data}
    }),
    options: permissions.map(data => {
      return {value: data, label: data}
    }),
    onChange: selectedOptions => configGroupsStore.setEditGroupPermissions(selectedOptions)
  }]
  return (
    <form>
      <FormRenderer fields={formFields} store={configGroupsStore} />
    </form>
  )
}))

export default EditGroupForm



// WEBPACK FOOTER //
// ./src/components/dashboard/config/groups/EditGroupForm.js